import React from "react";
import { Button, Grid, Typography, Box, Container, Accordion, AccordionSummary, AccordionDetails, IconButton, Drawer, List, ListItem, ListItemButton, Link } from "@mui/material";
import { Trans, withTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as HomeIcon } from "./assets/home.svg";
import { ReactComponent as VectorIcon } from "./assets/Vector.svg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import WisdomLogo from "./assets/wisdomLogo.png";
import whiteHeart from "./assets/whiteHeart.png";
import topArrow from "./assets/topArrow.png";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Footer from './components/Footer';
import MobileDrawer from './components/MobileDrawer';
import WebAppHeader from "./components/WebAppHeader";

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
  }

  toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ drawerOpen: open });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleGoHome = () => {
    const eventHandler = this.props.onClickGoToPage("Landing");
    eventHandler();
  };

  changeLanguage = (lng) => {
    this.props.i18n.changeLanguage(lng);
  };

  render() {
    const { expanded } = this.state;
    const { t, i18n } = this.props;

    return (
      <>
        {/* Header */}
            <WebAppHeader 
            t={t}
            i18n={i18n}
            view={this.props.view}
            changeLanguage={this.changeLanguage}
            onClickGoToPage={this.props.onClickGoToPage}
            onOpenDrawer={this.toggleDrawer(true)}
            Logo={WisdomLogo}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
          />
        
        {/* Mobile Drawer */}
        <MobileDrawer 
            open={this.state.drawerOpen}
            onClose={this.toggleDrawer(false)}
            t={t}
            i18n={i18n}
            changeLanguage={this.changeLanguage}
            currentView={this.props.view}
            onClickGoToPage={this.props.onClickGoToPage}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
        />

        {/* Main Content */}
        <Container
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
          }}
        >
          {/* Header Section */}
          <Box
            sx={{
              color: "#221F73",
              padding: "40px 0",
              textAlign: "center",
              marginBottom: "30px",
              borderRadius: "10px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: "2.5rem",
                marginBottom: "10px",
                fontWeight: "600",
              }}
            >
                {/* Frequently Asked Questions */}
                 {t('faq.title')}
            </Typography>
          </Box>

          {/* FAQ Sections */}
          {/* Study Overview Section */}
          <Box sx={{ marginBottom: "30px" }}>
            <Box
              sx={{
                background: "white",
                  borderRadius: "10px",
                  padding: "30px",
                  marginBottom: "30px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              <Typography
                  variant="h2"
                sx={{
                  color: "#D80C8C",
                    borderBottom: "3px solid #D80C8C",
                    paddingBottom: "10px",
                    marginBottom: "25px",
                    fontSize: "1.8rem",
                  fontWeight: "600",
                }}
              >
                  {/* Study Overview */}
                   {t('faq.h1')}
              </Typography>
                
                <Accordion 
                sx={{
                    marginBottom: "25px", 
                    borderLeft: "4px solid #D80C8C",
                    paddingLeft: "20px",
                    boxShadow: "none",
                    "&:before": { display: "none" },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
              sx={{
                      padding: 0,
                      minHeight: "auto",
                      "& .MuiAccordionSummary-content": {
                        margin: "0",
                      },
              }}
            >
              <Typography
                sx={{
                        fontWeight: "bold",
                        color: "#2c3e50",
                        fontSize: "1.1rem",
                        marginBottom: "10px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        "&:hover": {
                  color: "#D80C8C",
                        },
                }}
              >
                      {/* What is the WIsDoM Fertility Registry Study? */}
                      {t('faq.h1_q1')}

              </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                    <Typography sx={{ color: "#555", lineHeight: "1.7" }}>
                      {/* WIsDoM is the first long-term study (also called a prospective registry) designed to follow women with IBD who want to become pregnant, in order to better understand and measure the factors that can affect their fertility. */}
                      {t('faq.h1_q1_a1')}
                </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion 
                  sx={{
                    marginBottom: "25px", 
                    borderLeft: "4px solid #D80C8C",
                    paddingLeft: "20px",
                    boxShadow: "none",
                    "&:before": { display: "none" },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                  sx={{
                      padding: 0,
                      minHeight: "auto",
                      "& .MuiAccordionSummary-content": {
                        margin: "0",
                      },
                    }}
                  >
                <Typography
                  sx={{
                        fontWeight: "bold",
                        color: "#2c3e50",
                        fontSize: "1.1rem",
                        marginBottom: "10px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        "&:hover": {
                          color: "#D80C8C",
                        },
                      }}
                    >
                      {/* Who is Eligible for the WIsDoM Registry? */}
                      {t('faq.h1_q2')}
                      
                </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                    <Box sx={{ 
                      background: "#FFF0F8", 
                      borderLeft: "4px solid #D80C8C", 
                      padding: "20px", 
                      margin: "15px 0", 
                      borderRadius: "5px" 
                    }}>
                      <Box component="ul" sx={{ listStyle: "none", paddingLeft: 0 }}>
                        <Box component="li" sx={{ padding: "8px 0", borderBottom: "1px solid #d4edda", "&:before": { content: '"✓"', color: "#c991b4", fontWeight: "bold", marginRight: "10px" } }}>
                          {t('faq.h1_q2_a1')}
                        </Box>
                        <Box component="li" sx={{ padding: "8px 0", borderBottom: "1px solid #d4edda", "&:before": { content: '"✓"', color: "#c991b4", fontWeight: "bold", marginRight: "10px" } }}>
                          {t('faq.h1_q2_a2')}
                        </Box>
                        <Box component="li" sx={{ padding: "8px 0", borderBottom: "1px solid #d4edda", "&:before": { content: '"✓"', color: "#c991b4", fontWeight: "bold", marginRight: "10px" } }}>
                          {t('faq.h1_q2_a3')}
                        </Box>
                        <Box component="li" sx={{ padding: "8px 0", borderBottom: "1px solid #d4edda", "&:before": { content: '"✓"', color: "#c991b4", fontWeight: "bold", marginRight: "10px" } }}>
                          {t('faq.h1_q2_a4')}
                        </Box>
                        <Box component="li" sx={{ padding: "8px 0", "&:before": { content: '"✓"', color: "#c991b4", fontWeight: "bold", marginRight: "10px" } }}>
                         {t('faq.h1_q2_a5')}
                        </Box>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Box>

          <Box sx={{ marginBottom: "30px" }}>
            {/* Why is WISDOM Important Section */}
          <Box
            sx={{
              background: "white",
                borderRadius: "10px",
                padding: "30px",
                marginBottom: "30px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <Typography
                variant="h2"
              sx={{
                color: "#D80C8C",
                  borderBottom: "3px solid #D80C8C",
                  paddingBottom: "10px",
                  marginBottom: "25px",
                  fontSize: "1.8rem",
                fontWeight: "600",
              }}
            >
                {/* Why is WIsDoM Important? */}
                  {t('faq.h2')}
            </Typography>
              
              <Accordion 
              sx={{
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
            <Typography
              sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* Why is WIsDoM Important? */}
                    {t('faq.h2_q1')}
            </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ color: "#555", lineHeight: "1.7", marginBottom: "15px" }}>
                    {/* Over one million women in North America are living with inflammatory bowel disease (IBD), and most are diagnosed during their child-bearing years. These women deserve clear, evidence-based information when it comes to their fertility. Right now, many women with IBD choose not to have children due to fears about fertility that are not always based on accurate information. Unfortunately, we still don't have a national or international database focused on fertility and IBD, which limits our ability to provide the best guidance. */}
                    {t('faq.h2_q1_a1')}
                  </Typography>
                  <Typography sx={{ color: "#555", lineHeight: "1.7" }}>
                    {/* To better support women with IBD, we need high-quality, prospective research. This kind of data would help us understand the real risks of reduced fertility in this population, based on each person's unique health situation. It would also allow us to better counsel patients who are considering surgery, especially those undergoing procedures like IPAA or surgeries for Crohn's disease, where fertility might be affected. In addition, this research could help establish when to refer patients to fertility specialists, and even lead to tools—like a fertility risk calculator—that make counseling and planning more accurate and personalized. */}
                    {t('faq.h2_q1_a2')}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>

          {/* Participation & Procedures Section */}
          <Box sx={{ marginBottom: "30px" }}>
            <Box
              sx={{
                background: "white",
                borderRadius: "10px",
                padding: "30px",
                marginBottom: "30px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "#D80C8C",
                  borderBottom: "3px solid #D80C8C",
                  paddingBottom: "10px",
                  marginBottom: "25px",
                  fontSize: "1.8rem",
                  fontWeight: "600",
                }}
              >
                {/* Participation & Procedures */}
                  {t('faq.h3')}
              </Typography>
              
              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* What does participation in WIsDoM entail? */}
                    {t('faq.h3_q1')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ marginBottom: "15px", lineHeight: "1.7", color: "#555" }}>
                    {/* When you enroll in WIsDoM, you will be asked to complete an initial survey covering your medical, surgical, reproductive, and social history. Following this, you will receive monthly surveys to update us on any changes in your health or surgeries, your efforts to conceive, and whether you have become pregnant. */}
                    {t('faq.h3_q1_a1')}
                  </Typography>
                  <Typography sx={{ marginBottom: "15px", lineHeight: "1.7", color: "#555" }}>
                    {/* These monthly surveys will continue until you reach 12 weeks of pregnancy, at which point your participation in the study will be complete. */}
                   {t('faq.h3_q1_a2')}
                  </Typography>
                  <Typography sx={{ marginBottom: "15px", lineHeight: "1.7", color: "#555" }}>
                    {/* With your permission, we will also review your medical records to better understand your health history. */}
                     {t('faq.h3_q1_a3')}
                  </Typography>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* Please know that your participation is entirely voluntary, and you may choose to withdraw from the study at any time without any impact on your care. */}
                   {t('faq.h3_q1_a4')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* What if I forget to complete or miss a monthly survey? */}
                    {t('faq.h3_q2')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* We kindly ask that you complete the monthly surveys to the best of your ability. To help, we will send you reminders each month. If a survey is not completed within the expected timeframe, we may reach out to you by email or phone. If you happen to miss a month, simply continue with the surveys the following month. */}
                    {t('faq.h3_q2_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* Does participation require any visits? */}
                    {t('faq.h3_q3')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* No. Participation is questionnaire-based. You will not be asked to schedule any visits or submit any blood work. */}
                    {t('faq.h3_q3_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* Do I need to do any bloodwork or provide other samples for WIsDoM? */}
                    {t('faq.h3_q4')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* No, participants only need to complete surveys and authorize access to their medical records. */}
                    {t('faq.h3_q4_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* How do I join the study? */}
                    {t('faq.h3_q5')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>

                    <Trans
                      i18nKey="faq.h3_q5_a1"
                      components={{
                        pink: <Link href="https://www.redcap.link/wisdomibdstudy" 
                            underline="hover"
                            sx={{ 
                              color: "#D80C8C",
                              fontWeight: "600",
                              cursor: "pointer"
                             }} 

                          />
                      }} 
                    />
                
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>

          {/* Compensation & Privacy Section */}
          <Box sx={{ marginBottom: "30px" }}>
          <Box
            sx={{
              background: "white",
                borderRadius: "10px",
                padding: "30px",
                marginBottom: "30px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <Typography
                variant="h2"
              sx={{
                color: "#D80C8C",
                  borderBottom: "3px solid #D80C8C",
                  paddingBottom: "10px",
                  marginBottom: "25px",
                  fontSize: "1.8rem",
                fontWeight: "600",
              }}
            >
                {/* Compensation & Privacy */}
                  {t('faq.h4')}
            </Typography>
              
              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
            <Typography
              sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* Will I be compensated for participating in the WIsDoM study? */}
                    {t('faq.h4_q1')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* Yes! Upon completion of the baseline patient survey and a medical record release form, you will receive a $50 Amazon gift card. You will then receive a second $50 gift card upon study completion (reaching 12 weeks of pregnancy or end of the study period, which is currently set for July 31, 2027). */}
                    {t('faq.h4_q1_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* How is my personal information protected? */}
                    {t('faq.h4_q2')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* We keep your personal information completely confidential. Only the study team has access to it, and we do not share it with anyone outside the team. */}
                    {t('faq.h4_q2_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* Who do I contact if I have questions about the study? */}
                    {t('faq.h4_q3')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  
                     <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                          <Trans
                            i18nKey="faq.h4_q3_a1" 
                            components={{
                              email: (
                                <Link 
                                  href="mailto:wisdom@mssm.edu"
                                  underline="hover"
                                  sx={{ 
                                    color: "#D80C8C", 
                                    fontWeight: "600",
                                    cursor: "pointer" 
                                  }} 
                                />
                              ),
                              phone: (
                                <Link 
                                  href="tel:212-824-7786"
                                  underline="hover"
                                  sx={{ 
                                    color: "#D80C8C", 
                                    fontWeight: "600",
                                    cursor: "pointer" 
                                  }} 
                                />
                              )
                            }}
                          />
                      </Typography>

                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>

          {/* Study Outcomes & Support Section */}
          <Box sx={{ marginBottom: "30px" }}>
            <Box
              sx={{
                background: "white",
                borderRadius: "10px",
                padding: "30px",
                marginBottom: "30px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "#D80C8C",
                  borderBottom: "3px solid #D80C8C",
                  paddingBottom: "10px",
                  marginBottom: "25px",
                  fontSize: "1.8rem",
                  fontWeight: "600",
                }}
              >
                {/* Study Outcomes & Support */}
                  {t('faq.h5')}
              </Typography>
              
              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* What are the aims of the WIsDoM study? */}
                    {t('faq.h5_q1')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555", marginBottom: "15px" }}>
                    {/* We want to better understand which factors might affect fertility in women with IBD. */}
                    {t('faq.h5_q1_a1')}
                  </Typography>
                  <Typography sx={{ lineHeight: "1.7", color: "#555", marginBottom: "15px" }}>
                    {/* Our main goal is to learn how different types of IBD surgery may impact your fertility (the ability to become pregnant with timed, unprotected intercourse), and how long it may take to become pregnant. */}
                    {t('faq.h5_q1_a2')}
                  </Typography>
                  <Typography sx={{ lineHeight: "1.7", color: "#555", marginBottom: "15px" }}>
                    {/* We're also looking at whether the type of surgery—laparoscopic (minimally invasive) versus open surgery—affects fertility or time to pregnancy. */}
                     {t('faq.h5_q1_a3')}
                  </Typography>
                  <Typography sx={{ lineHeight: "1.7", color: "#555", marginBottom: "15px" }}>
                    {/* In addition, we're exploring other factors that might play a role, including: */}
                     {t('faq.h5_q1_a4')}
                  </Typography>
                  <Box component="ul" sx={{ paddingLeft: "20px", marginBottom: "15px" }}>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a5')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a6')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a7')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a8')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a9')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q1_a10')}</Box>
                  </Box>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* By learning more about these factors, we hope to provide better, more personalized support and guidance for women with IBD who are planning for pregnancy. */}
                     {t('faq.h5_q1_a11')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* What Questions will WIsDoM Answer? */}
                     {t('faq.h5_q2')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555", marginBottom: "15px" }}>
                    {/* Our study aims to answer important questions about fertility in women with IBD, including: */}
                     {t('faq.h5_q2_a1')}
                  </Typography>
                  <Box component="ul" sx={{ paddingLeft: "20px", marginBottom: "15px" }}>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}> {t('faq.h5_q2_a2')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a3')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a4')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a5')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a6')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a7')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a8')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a9')}</Box>
                    <Box component="li" sx={{ marginBottom: "8px", color: "#555" }}>{t('faq.h5_q2_a10')}</Box>
                  </Box>
                </AccordionDetails>
              </Accordion>

              <Accordion 
                sx={{ 
                  marginBottom: "25px", 
                  borderLeft: "4px solid #D80C8C",
                  paddingLeft: "20px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 0,
                    minHeight: "auto",
                    "& .MuiAccordionSummary-content": {
                      margin: "0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontSize: "1.1rem",
                      marginBottom: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover": {
                        color: "#D80C8C",
                      },
                    }}
                  >
                    {/* What if I don't get pregnant or my pregnancy does not make it to 12 weeks? */}
                    {t('faq.h5_q3')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 0 0 20px" }}>
                  <Typography sx={{ lineHeight: "1.7", color: "#555" }}>
                    {/* We know that the journey to pregnancy can be difficult and sometimes disappointing. Your participation is helpful to us, no matter the outcome, because your experience strengthens our understanding of fertility in women with IBD and will help others on the same path in the future. */}
                    {t('faq.h5_q3_a1')}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>
        </Container>

    
         {/* Footer */}
        <Footer 
            t={t} 
            onClickGoToPage={this.props.onClickGoToPage} 
            whiteHeart={whiteHeart} 
            topArrow={topArrow} 
          />

      </>
    );
  }
}
export default withTranslation()(FAQ);